import { render, staticRenderFns } from "./CaseStatusBadge.vue?vue&type=template&id=6f0135a4"
import script from "./CaseStatusBadge.vue?vue&type=script&lang=js"
export * from "./CaseStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports